import React from "react";
import ProjectsListing from "../ProjectListing/ProjectListing";

const MusicVideo = () => {
  return <ProjectsListing categoryKey="filmProjects" baseUrl="film" />;
};

export default MusicVideo;
